/* LIETUVA GROJA DABAR — V50 frontend.
   Kreipiasi TIK į viešą Worker `/live/full`. TinyURL tokeno naršyklė nemato.
   Sąmoningai NĖRA „kompanijų" skaitiklio: TinyURL duoda paspaudimus, ne
   sesijas, todėl toks skaičius būtų išgalvotas. */
(function () {
  'use strict';

  var REFRESH_MS = 60000;
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function ago(iso) {
    var s = Math.max(0, Math.floor((Date.now() - new Date(iso).getTime()) / 1000));
    if (s < 60) return 'ką tik';
    var m = Math.floor(s / 60);
    if (m < 60) return 'prieš ' + m + ' min.';
    var h = Math.floor(m / 60);
    if (h < 24) return 'prieš ' + h + ' val.';
    var d = Math.floor(h / 24);
    return 'prieš ' + d + (d === 1 ? ' dieną' : ' d.');
  }

  function clock(iso) {
    var d = new Date(iso);
    return ('0' + d.getHours()).slice(-2) + ':' + ('0' + d.getMinutes()).slice(-2);
  }

  /* Burbulo dydis - bucket skale, NIEKADA ne tiesiskai proporcinga. */
  function radius(n) {
    if (n >= 21) return 30;
    if (n >= 11) return 25;
    if (n >= 6) return 21;
    if (n >= 3) return 17;
    return 13;
  }

  function LiveNow(root) {
    /* ------------------------------------------------------------------
       V73 · MAP-001 — IDEMPOTENT INIT.

       Problema: `init()` kviečiamas ir per DOMContentLoaded, ir per
       `shopify:section:load`. Theme editoriuje kiekvienas sekcijos
       perkrovimas kviesdavo `LiveNow()` iš naujo TAM PAČIAM elementui.
       Kiekvienas iškvietimas registruodavo:
         • `setInterval(load, 60000)` — naują timerį;
         • `document`-lygio `visibilitychange` — naują listenerį;
         • `root`-lygio click ir keydown listenerius.

       Seni timeriai niekada nebūdavo išvalyti, nes `stop()` gyvena
       ankstesnio iškvietimo uždarinyje. Rezultatas: po N perkrovimų
       `/live/full` kviečiamas N kartų per minutę.

       Sprendimas dviejų dalių:
       1. `dataset.lgReady` — tas pats elementas inicializuojamas
          vieną kartą.
       2. Ankstesnio egzemplioriaus `visibilitychange` listeneris
          nuimamas per `AbortController` signalą, todėl net jei Shopify
          atiduotų naują DOM mazgą su ta pačia sekcija, senas listeneris
          nelieka kabėti.
       ------------------------------------------------------------------ */
    if (root.dataset.lgReady === '1') return;
    root.dataset.lgReady = '1';

    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    var api = (root.dataset.endpoint || '').replace(/\/+$/, '');
    var preview = root.dataset.preview === 'true';
    if (!api && !preview) return;

    var feedLimit = parseInt(root.dataset.feed, 10) || 8;
    var isFull = root.dataset.full === 'true';

    var el = {
      bubbles: root.querySelector('[data-lg-bubbles]'),
      feed: root.querySelector('[data-lg-feed]'),
      title: root.querySelector('[data-lg-title]'),
      reset: root.querySelector('[data-lg-reset]'),
      empty: root.querySelector('[data-lg-empty]'),
      mapEmpty: root.querySelector('[data-lg-mapempty]'),
      status: root.querySelector('[data-lg-status]'),
      sync: root.querySelector('[data-lg-sync]'),
      plays: root.querySelector('[data-lg-plays]'),
      cities: root.querySelector('[data-lg-cities]'),
      edition: root.querySelector('[data-lg-edition]'),
      topcity: root.querySelector('[data-lg-topcity]'),
      editions: root.querySelector('[data-lg-editions]'),
      top: root.querySelector('[data-lg-top]'),
      pulse: root.querySelector('[data-lg-pulse]'),
      stories: root.querySelector('[data-lg-stories]')
    };

    var seenBefore = {};
    /* V124 · LIVE-04 — BŪSENA ATSISPINDI URL'E.

       Iki šiol filtrai gyveno tik atmintyje: pasirinkus „7 dienos" ir
       atnaujinus puslapį viskas grįždavo į pradinę būseną, o pasidalinti
       konkrečiu pjūviu buvo neįmanoma.

       Priimami TIK sąraše esantys parametrai (whitelist). Bet kokia kita
       reikšmė ignoruojama — taip URL negali įstumti į būseną, kurios UI
       nemoka parodyti.

       `replaceState`, ne `pushState`: kitaip kiekvienas mygtuko
       paspaudimas pridėtų įrašą į istoriją ir „Atgal" taptų nenaudojamas. */
    /* V136 — tik du langai, kuriuos Worker'is realiai palaiko. '1d', '24h', '30d'
       Worker'is tyliai paverčia 'today', todėl jų nesiūlome. Numatytasis — 7d:
       pirmas įspūdis turi rodyti savaitę, ne kelias rytines valandas. */
    var LIVE_WINDOWS = ['today', '7d'];
    var LIVE_PRODUCTS = ['all', 'original', 'kernagis', 'expansions'];

    function readState() {
      var st = { window: '7d', product: 'all', city: null };
      try {
        var q = new URLSearchParams(window.location.search);
        var w = q.get('window') || q.get('lg_window'), pr = q.get('product') || q.get('lg_product'), c = q.get('city') || q.get('lg_city');
        if (w && LIVE_WINDOWS.indexOf(w) !== -1) st.window = w;
        if (pr && LIVE_PRODUCTS.indexOf(pr) !== -1) st.product = pr;
        if (c) st.city = c.slice(0, 40);
      } catch (e) { /* senos naršyklės — lieka numatytoji būsena */ }
      return st;
    }

    function writeState() {
      try {
        var u = new URL(window.location.href);
        ['lg_window', 'lg_product', 'lg_city'].forEach(function (k) { u.searchParams.delete(k); });
        u.searchParams.set('window', state.window);
        if (state.product === 'all') u.searchParams.delete('product');
        else u.searchParams.set('product', state.product);
        if (state.city) u.searchParams.set('city', state.city);
        else u.searchParams.delete('city');
        window.history.replaceState({}, '', u.toString());
      } catch (e) { /* URL neatnaujinamas — filtrai vis tiek veikia */ }
    }

    var state = readState();
    var lastGood = null, seen = {}, controller = null, timer = null;

    function setStats(d) {
      if (el.plays) el.plays.textContent = d.stats.plays;
      if (el.cities) el.cities.textContent = d.stats.active_cities;
      if (el.edition) el.edition.textContent = d.stats.top_edition || '\u2014';
      if (el.topcity) el.topcity.textContent = d.stats.top_city || '\u2014';
    }

    /* ------------------------------------------------------------------
       V76 · MAP-002 — TOUCH TARGET.

       IŠMATUOTA v75 (tikras Preview): interaktyvaus burbulo `<g>` dydis
         1440 px -> 23,5 CSS px
          430 px -> 10,6
          390 px ->  9,4
          360 px ->  8,5
       Visur gerokai mažiau nei WCAG 2.5.5 reikalaujami 44x44.

       KODĖL NEPAKANKA TIESIOG PADIDINTI `r`:
       SVG turi `viewBox="0 0 880 620"`, o atvaizduojamas plotis kinta,
       todėl mastelis 390 px ekrane yra 0,3614. Kad hitbox būtų 44 CSS px,
       spindulys turėtų būti 22 / 0,3614 = 61 SVG vienetas — beveik 7 %
       žemėlapio pločio. Fiksuotas `r` negali duoti pastovaus CSS dydžio.

       KODĖL NEGALIMA AKLAI TAIKYTI 61:
       Dalis savivaldybių turi SUTAMPANČIAS koordinates (Kauno miestas ir
       Kauno rajonas — atstumas 0,0), o Alytaus miestas ir Alytus — 11,6.
       61 vieneto zonos persidengtų ir vartotojas pataikytų į NE TĄ miestą.
       Task tai draudžia.

       SPRENDIMAS — hitbox skaičiuojamas, o ne fiksuotas:
         hitR = max(matomas_r, min(22 / mastelis, pusė_atstumo_iki_kaimyno))

       Taip izoliuoti miestai gauna pilnus 44 CSS px, o susigrūdę —
       didžiausią įmanomą zoną, kuri dar NEPERSIDENGIA. Neteisingo miesto
       pasirinkti neįmanoma.

       Piešimo tvarka: mažesni burbulai piešiami PASKUTINIAI, todėl jie
       lieka viršuje ir didelio kaimyno nepraryjami. Tai deterministiška.

       Perskaičiuojama per `ResizeObserver`, nes mastelis kinta keičiant
       lango dydį ar pasukus telefoną.
       ------------------------------------------------------------------ */

    /** Kiek CSS pikselių tenka vienam SVG vienetui dabartiniame plotyje. */
    function mapScale() {
      var svg = root.querySelector('svg.lgmap');
      if (!svg) return 1;
      var w = svg.getBoundingClientRect().width;
      var vb = svg.viewBox && svg.viewBox.baseVal ? svg.viewBox.baseVal.width : 880;
      return w && vb ? w / vb : 1;
    }

    /** Pusė atstumo iki artimiausio kito burbulo — riba, kad nepersidengtų. */
    function halfNearest(c, list) {
      var min = Infinity;
      list.forEach(function (o) {
        if (o === c) return;
        var dx = o.x - c.x, dy = o.y - c.y;
        var d = Math.sqrt(dx * dx + dy * dy);
        if (d > 0.01 && d < min) min = d;
      });
      return min === Infinity ? Infinity : min / 2;
    }

    /** Perskaičiuoja nematomų hit zonų spindulius pagal dabartinį mastelį. */
    function sizeHitAreas() {
      if (!el.bubbles) return;
      var scale = mapScale();
      if (!scale) return;
      var needed = 22 / scale;               // 44 CSS px skersmuo
      var hits = el.bubbles.querySelectorAll('.lgbub__hit');
      hits.forEach(function (h) {
        var vis = parseFloat(h.dataset.visR) || 13;
        var cap = parseFloat(h.dataset.cap);
        var r = Math.min(needed, isFinite(cap) ? cap : needed);
        h.setAttribute('r', String(Math.max(vis, r)));
      });
    }

    function renderBubbles(cities) {
      if (!el.bubbles) return;
      el.bubbles.innerHTML = '';
      /* Mažesni paskutiniai -> viršuje. Neteisingas miestas nepasirenkamas. */
      var ordered = cities.slice().sort(function (a, b) { return b.count - a.count; });
      ordered.forEach(function (c) {
        var g = document.createElementNS('http://www.w3.org/2000/svg', 'g');
        var cls = 'lgbub' + (c.live ? ' is-live' : '');
        if (state.city && state.city !== c.city) cls += ' is-dim';
        if (state.city === c.city) cls += ' is-on';
        g.setAttribute('class', cls);
        g.setAttribute('tabindex', '0');
        g.setAttribute('role', 'button');
        g.setAttribute('aria-label', c.city + ', ' + c.count + ' paleidimai');
        g.dataset.city = c.city;

        /* Nematoma paspaudimo zona. Pirma vaikas, kad liktų PO matomu
           burbulu ir nedengtų skaičiaus. `fill` privalo būti nustatytas,
           kitaip SVG elementas įvykių negauna. */
        var hit = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
        hit.setAttribute('cx', c.x); hit.setAttribute('cy', c.y);
        hit.setAttribute('class', 'lgbub__hit');
        hit.dataset.visR = String(radius(c.count));
        var cap = halfNearest(c, ordered);
        if (isFinite(cap)) hit.dataset.cap = String(cap);
        hit.setAttribute('r', String(radius(c.count)));

        var circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
        circle.setAttribute('cx', c.x); circle.setAttribute('cy', c.y);
        circle.setAttribute('r', radius(c.count));
        circle.setAttribute('class', 'lgbub__dot');
        var t = document.createElementNS('http://www.w3.org/2000/svg', 'text');
        t.setAttribute('x', c.x); t.setAttribute('y', c.y + 5);
        t.setAttribute('text-anchor', 'middle'); t.setAttribute('class', 'lgbub__n');
        t.textContent = c.count;
        g.appendChild(hit); g.appendChild(circle); g.appendChild(t);
        el.bubbles.appendChild(g);
      });
      sizeHitAreas();
      if (el.mapEmpty) el.mapEmpty.hidden = cities.length > 0;
    }

    function renderFeed(feed) {
      if (!el.feed) return;
      el.feed.innerHTML = '';
      feed.slice(0, feedLimit).forEach(function (e) {
        var li = document.createElement('li');
        li.className = 'lgitem';
        if (!REDUCED && !seen[e.id]) li.classList.add('is-new');
        seen[e.id] = 1;
        li.innerHTML =
          '<div class="lgitem__main">' +
            '<p class="lgitem__meta">' + esc(ago(e.timestamp)) +
              (e.city ? ' \u00b7 ' + esc(e.city) : '') + '</p>' +
            '<b class="lgitem__a">' + esc(e.artist) + '</b>' +
            '<span class="lgitem__s">' + esc(e.song) + '</span>' +
          '</div>' +
          '';
        el.feed.appendChild(li);
      });
      if (el.empty) el.empty.hidden = feed.length > 0;

      /* V124 · LIVE-08 — PRANEŠIMAS SKAITYTUVUI BE PERKROVOS.
         `aria-live` ant viso sąrašo skaitytų kiekvieną įrašą po
         kiekvieno atnaujinimo. Vietoje to atnaujinama viena trumpa
         santrauka — tiek, kad žmogus žinotų, jog duomenys pasikeitė. */
      var st = root.querySelector('[data-lg-announce]');
      if (st) {
        var fresh = feed.slice(0, feedLimit).filter(function (x) { return !seenBefore[x.id]; }).length;
        feed.slice(0, feedLimit).forEach(function (x) { seenBefore[x.id] = 1; });
        if (fresh > 0) st.textContent = fresh + ' nauji paleidimai sąraše';
      }
    }


  /* V124 · LIVE-06 — ŽYMA VEDA Į PDP, BET TIK PAGAL CANONICAL HANDLE.

     Worker atsakyme yra ir `product` (handle), ir `product_label`.
     Iki šiol žyma buvo tik tekstas — spustelėti nebuvo kur.

     Handle NIEKADA nespėjamas iš dainos pavadinimo (DATA-10). Jei
     Worker grąžintų nežinomą handle, nuoroda NEKURIAMA — lieka
     paprasta žyma. Taip sulūžusi nuoroda tampa neįmanoma. */
  /* Canonical vieši pavadinimai. Tas pats šaltinis, kaip katalogo
     grupėse ir kortelėse — kad viename puslapyje tas pats produktas
     nesivadintų dviem vardais. */
  var LIVE_LABELS = {
    'muzikinis-zaidimas': 'MUZIKINIS ŽAIDIMAS - PIRMA DALIS',
    'muzikinis-zaidimas-x-agata': 'MUZIKINIS ŽAIDIMAS - AGATA',
    'muzikinis-zaidimas-x-kernagis': 'MUZIKINIS ŽAIDIMAS - KERNAGIS',
    'po-dutukstantuju': 'PO DUTŪKSTANTŲJŲ',
    'paklausom-is-naujo': 'PAKLAUSOM IŠ NAUJO',
    'baltos-kaledos': 'BALTOS KALĖDOS',
    'musu-dienos-kaip-svente': 'MŪSŲ DIENOS, KAIP ŠVENTĖ'
  };
  var LIVE_HANDLES = {
    'muzikinis-zaidimas': 1,
    'muzikinis-zaidimas-x-agata': 1,
    'muzikinis-zaidimas-x-kernagis': 1,
    'po-dutukstantuju': 1,
    'paklausom-is-naujo': 1,
    'baltos-kaledos': 1,
    'musu-dienos-kaip-svente': 1
  };
  function lgTag(handle, label) {
    if (!label) return '';
    var t = esc(label);
    if (handle && LIVE_HANDLES[handle]) {
      return '<a class="lgtag lgtag--link" href="/products/' + esc(handle) +
             '" aria-label="' + t + ' \u2014 atidaryti produkto puslapi">' + t + '</a>';
    }
    return '<span class="lgtag">' + t + '</span>';
  }

    function renderEditions(list) {
      if (!el.editions) return;
      el.editions.innerHTML = list.map(function (e) {
        /* V125 · LIVE-05 — KPI ANTRAŠTĖ NEBEDVIPRASMĖ.

           Worker grąžina `label: "MUZIKINIS ŽAIDIMAS"`. Puslapyje, kur
           šalia rodomi AGATA ir Kernagio leidimas, tai skaitosi kaip
           BRANDAS, ne kaip konkretus leidimas — o skaičius po juo yra
           būtent Originalo.

           Todėl viešas pavadinimas imamas iš canonical žemėlapio pagal
           handle. Worker `label` lieka kaip atsarga nežinomiems handle. */
        var edLabel = LIVE_LABELS[e.product] || e.label;
        return '<article class="lged"><b class="lged__t">' + esc(edLabel) + '</b>' +
          '<p class="lged__row"><b class="num">' + e.plays + '</b> paleidimai</p>' +
          '<p class="lged__row"><b class="num">' + e.cities + '</b> miestai</p>' +
          '<p class="lged__songs">' + e.songs_total + ' dainų repertuare</p></article>';
      }).join('');
    }

    function renderTop(list) {
      if (!el.top) return;
      el.top.innerHTML = list.map(function (s, i) {
        return '<li class="lgtop__i"><span class="lgtop__n num">' + (i + 1) + '</span>' +
          '<span class="lgtop__t"><b>' + esc(s.artist) + '</b> \u2014 ' + esc(s.song) + '</span>' +
          '' +
          '<span class="lgtop__c">' + s.plays + ' paleidimai \u00b7 ' + s.cities + ' miestai</span></li>';
      }).join('');
    }

    function renderPulse(list) {
      if (!el.pulse) return;
      el.pulse.innerHTML = list.map(function (c, i) {
        return '<li class="lgpulse__i"><span class="lgtop__n num">' + (i + 1) + '</span>' +
          '<b class="lgpulse__c">' + esc(c.city) + '</b>' +
          '<span class="lgpulse__p">' + c.plays + ' paleidimai</span>' +
          '' +
          '</li>';
      }).join('');
    }

    function renderStories(s) {
      if (!el.stories) return;
      var parts = [];
      if (s.first_play) parts.push('<div class="lgstory"><p class="lgstory__l">Pirmoji daina</p>' +
        '<p class="lgstory__v">' + esc(clock(s.first_play.time)) + ' ' +
        esc(s.first_play.city || 'Lietuvoje') + ' \u2014 ' + esc(s.first_play.artist) +
        ', ' + esc(s.first_play.song) + '</p></div>');
      if (s.newest_city) parts.push('<div class="lgstory"><p class="lgstory__l">Naujausias užsidegęs miestas</p>' +
        '<p class="lgstory__v">' + esc(clock(s.newest_city.time)) + ' ' + esc(s.newest_city.city) + '</p></div>');
      if (s.peak_hour) { var h = ('0' + s.peak_hour.hour).slice(-2);
        parts.push('<div class="lgstory"><p class="lgstory__l">Aktyviausia valanda</p>' +
        '<p class="lgstory__v">' + h + ':00\u2013' + h + ':59 \u00b7 ' + s.peak_hour.plays + ' paleidimai</p></div>'); }
      el.stories.innerHTML = parts.join('') ||
        '<p class="lgnow__empty">Per pasirinktą laiką istorijų dar nėra.</p>';
    }

    function paint(d) {
      setStats(d);
      renderBubbles(d.cities || []);
      renderFeed(d.feed || []);
      if (isFull) {
        renderEditions(d.editions || []);
        renderTop(d.top_songs || []);
        renderPulse(d.city_pulse || []);
        renderStories(d.stories || {});
      }
      if (el.title) el.title.textContent = state.city
        ? state.city.toUpperCase() + ' GROJA' : 'LIETUVA GROJA';
      if (el.reset) el.reset.hidden = !state.city;
      if (el.status) el.status.hidden = !d.degraded;
      if (el.sync) el.sync.textContent = 'Atnaujinta ' + ago(d.updated_at);
    }

    /* PERŽIŪROS REŽIMAS — demonstraciniai duomenys UI patikrai.
       Naudojami TIK kai nėra endpointo ir sekcijoje įjungtas preview.
       Realiam puslapiui jie nepasiekiami. */
    function demoData() {
      var now = Date.now();
      var C = [['Vilnius',613.5,416.9,13,true],['Kaunas',435.3,369.9,9,true],
        ['Klaipėda',83.6,187.4,4,false],['Šiauliai',362.5,138,6,true],
        ['Panevėžys',494.6,182.7,3,false],['Alytus',486,475,5,true],
        ['Marijampolė',366.8,443.8,2,false],['Utena',654.4,235,4,true]];
      var F = [['Rondo','Laukų gėlė','Vilnius','MUZIKINIS ŽAIDIMAS',2],
        ['Andrius Mamontovas','Saulės miestas','Kaunas','MUZIKINIS ŽAIDIMAS',4],
        ['Antanas Šabaniauskas','Paskutinį sekmadienį','Klaipėda','MUZIKINIS ŽAIDIMAS - AGATA',5],
        ['Keistuolių Teatras','Ačiū, kad žiūrjot','Šiauliai','MUZIKINIS ŽAIDIMAS',6],
        ['Dinamika','Tu palinkėk','Panevėžys','MUZIKINIS ŽAIDIMAS',8],
        ['SEL','Lyja','Alytus','PO DUTŪKSTANTŲJŲ',9],
        ['G&G Sindikatas','Nenormalei','Marijampolė','MUZIKINIS ŽAIDIMAS',10],
        ['Biplan','Kelionė','Utena','MUZIKINIS ŽAIDIMAS',12]];
      return {
        updated_at: new Date(now - 40000).toISOString(),
        stats: { plays: 486, active_cities: C.length,
          top_edition: 'MUZIKINIS ŽAIDIMAS', top_city: 'Vilnius' },
        cities: C.map(function (c, i) {
          return { code: String(i), city: c[0], x: c[1], y: c[2], count: c[3], live: c[4] }; }),
        feed: F.map(function (f, i) {
          return { id: 'demo' + i, timestamp: new Date(now - f[4] * 60000).toISOString(),
            city: f[2], artist: f[0], song: f[1], product: 'x', product_label: f[3] }; }),
        top_songs: F.map(function (f, i) {
          return { artist: f[0], song: f[1], product_label: f[3],
            plays: 38 - i * 3, cities: 9 - Math.floor(i / 2) }; }),
        city_pulse: C.slice(0, 5).map(function (c) {
          return { city: c[0], plays: c[3] * 24, top_product_label: 'MUZIKINIS ŽAIDIMAS' }; }),
        editions: [
          { product: 'a', label: 'MUZIKINIS ŽAIDIMAS', plays: 289, cities: 14, songs_total: 300 },
          { product: 'b', label: 'MUZIKINIS ŽAIDIMAS - AGATA', plays: 121, cities: 8, songs_total: 300 },
          { product: 'c', label: 'MUZIKINIS ŽAIDIMAS - KERNAGIS', plays: 76, cities: 6, songs_total: 350 }],
        stories: {
          first_play: { time: new Date(now - 11 * 3600000).toISOString(),
            city: 'Vilnius', artist: 'Rondo', song: 'Laukų gėlė' },
          newest_city: { time: new Date(now - 22 * 60000).toISOString(), city: 'Utena' },
          peak_hour: { hour: 19, plays: 84 } },
        degraded: false };
    }

    function load() {
      writeState();
      if (!api && preview) { paint(demoData()); return; }
      if (controller) controller.abort();
      controller = new AbortController();
      var q = new URLSearchParams();
      q.set('window', state.window);
      q.set('product', state.product);
      q.set('limit', feedLimit);
      if (state.city) q.set('city', state.city);
      /* V73 · MAP-001 — `response.ok` patikra.
         Buvo `.then(r => r.json())`. Worker 500 su JSON klaidos kūnu
         būtų perduotas `paint()`, ir žemėlapis nupieštų klaidos objektą
         kaip tikrus duomenis: 0 paleidimų, 0 miestų, tuščias feed'as —
         atrodytų kaip „šiandien niekas nežaidė", o ne kaip gedimas.
         Dabar HTTP klaida krenta į `.catch`, kuris rodo `degraded`
         paskutinį gerą rezultatą arba klaidos būseną. */
      fetch(api + '?' + q.toString(), { signal: controller.signal })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.json();
        })
        .then(function (d) { lastGood = d; paint(d); })
        .catch(function (err) {
          if (err.name === 'AbortError') return;
          if (lastGood) { lastGood.degraded = true; paint(lastGood); }
          else if (el.status) el.status.hidden = false;
        });
    }

    function setChip(value, attr) {
      root.querySelectorAll('[' + attr + ']').forEach(function (b) {
        var on = b.getAttribute(attr) === value;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }

    root.addEventListener('click', function (e) {
      var w = e.target.closest('[data-lg-window]');
      if (w) { state.window = w.dataset.lgWindow; setChip(state.window, 'data-lg-window'); load(); return; }
      var p = e.target.closest('[data-lg-product]');
      if (p) { state.product = p.dataset.lgProduct; setChip(state.product, 'data-lg-product'); load(); return; }
      var b = e.target.closest('[data-city]');
      if (b) { state.city = b.dataset.city; load(); return; }
      if (e.target.closest('[data-lg-reset]')) { state.city = null; load(); }
    });

    root.addEventListener('keydown', function (e) {
      var b = e.target.closest('[data-city]');
      if (b && (e.key === 'Enter' || e.key === ' ')) {
        e.preventDefault(); state.city = b.dataset.city; load();
      }
    });

    function start() { stop(); load(); timer = setInterval(load, REFRESH_MS); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    /* Nuoroda į `stop`, kad `shopify:section:unload` galėtų sustabdyti
       būtent šio egzemplioriaus timerį. */
    root._lgStop = stop;

    /* V76 · MAP-002: mastelis kinta keičiant langą ar pasukus telefoną,
       todėl hit zonas perskaičiuojame. `ResizeObserver` tikslesnis už
       `window.resize`, nes reaguoja ir į konteinerio pokyčius. */
    if (typeof ResizeObserver === 'function') {
      var svgEl = root.querySelector('svg.lgmap');
      if (svgEl) {
        var ro = new ResizeObserver(function () { sizeHitAreas(); });
        ro.observe(svgEl);
        root._lgRO = ro;
      }
    }

    /* V73 · MAP-001: listeneris su `signal`, kad jį būtų galima nuimti.
       Be to — `pagehide` sustabdo timerį, kai vartotojas išeina iš
       puslapio (bfcache), o `pageshow` jį atkuria. Anksčiau timeris
       galėjo likti veikti bfcache'e ir po grįžimo dubliuotis. */
    var ac = typeof AbortController === 'function' ? new AbortController() : null;
    var opts = ac ? { signal: ac.signal } : false;
    root._lgAbort = ac;

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else start();
    }, opts);

    window.addEventListener('pagehide', stop, opts);
    window.addEventListener('pageshow', function (e) { if (e.persisted) start(); }, opts);

    /* Atkūrus būseną iš URL, mygtukai turi ją atspindėti — kitaip
       aktyvus filtras rodytų vieną, o duomenys būtų kito pjūvio. */
    setChip(state.window, 'data-lg-window');
    setChip(state.product, 'data-lg-product');

    start();
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-lgroja]').forEach(LiveNow);
  }

  /* V73 · MAP-001: kai Shopify pašalina sekciją (editoriuje arba
     perkraudamas), nuimame jos listenerius ir timerį. Be šito jie
     liktų kabėti iki puslapio perkrovimo. */
  document.addEventListener('shopify:section:unload', function (e) {
    var root = e.target && e.target.querySelector
      ? e.target.querySelector('[data-lgroja]') : null;
    if (root && root._lgAbort) { try { root._lgAbort.abort(); } catch (err) {} }
    if (root && root._lgStop) { try { root._lgStop(); } catch (err) {} }
    if (root && root._lgRO) { try { root._lgRO.disconnect(); } catch (err) {} }
  });

  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  if (document.readyState !== 'loading') init(document);
})();

/* V136 — PDP antraštės paleidimų langelis.
   ---------------------------------------------------------------------------
   Pakeičia v123–v135 „GYVAI juostą", kuri niekada neatsidarydavo: Liquid jai
   išvesdavo data-live-scope="global", o šis kodas reikalavo data-product-handle
   ir be jo iškart grįždavo. Dvi failo pusės nesusikalbėjo.

   Dabar:
   - langas 7 dienos (vienas iš dviejų, kuriuos Worker'is realiai palaiko);
   - skaičius imamas iš editions[] pagal handle — jokio globalaus skaičiaus,
     apsimetančio konkretaus leidimo aktyvumu;
   - rinkiniui data-handles turi kelis handle, jų paleidimai sumuojami;
   - rodoma tik nuo data-min (numatyta 100): „grojo 19 kartų" šalia
     „300 dainų" ne sustiprina, o susilpnina;
   - AGATA editions[] masyve NIEKADA nebus: jos kortelės dainas atidaro per
     PAKARTOT.LT, ne per parduotuvės nuorodų sekiklį. Langelis lieka paslėptas.
   Nepavykus užklausai — langelis lieka paslėptas, puslapis nesugenda. */
(function () {
  'use strict';

  function ltWord(n) {
    var m10 = n % 10, m100 = n % 100;
    if (m10 === 1 && m100 !== 11) return 'kartą';
    if (m10 >= 2 && m10 <= 9 && !(m100 >= 11 && m100 <= 19)) return 'kartus';
    return 'kartų';
  }
  function fmt(n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '\u00a0'); }

  function init() {
    var els = document.querySelectorAll('[data-live-plays]');
    if (!els.length) return;
    var api = (els[0].dataset.endpoint || '').replace(/\/+$/, '');
    if (!api) return;
    var u;
    try { u = new URL(api); } catch (e) { return; }
    u.search = new URLSearchParams({ window: '7d' }).toString();

    fetch(u.toString(), { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
      .then(function (d) {
        var by = {};
        ((d && d.editions) || []).forEach(function (e) {
          if (e && e.product && typeof e.plays === 'number') by[e.product] = e.plays;
        });
        els.forEach(function (el) {
          var hs = String(el.dataset.handles || '').split(',');
          var n = 0, any = false;
          hs.forEach(function (h) {
            h = h.trim();
            if (h && Object.prototype.hasOwnProperty.call(by, h)) { n += by[h]; any = true; }
          });
          var min = parseInt(el.dataset.min || '100', 10);
          if (!any || n < min) return;
          var nn = el.querySelector('[data-live-n]');
          var ww = el.querySelector('[data-live-w]');
          if (nn) nn.textContent = fmt(n);
          if (ww) ww.textContent = ltWord(n);
          el.hidden = false;
          var head = el.closest('[data-pdphead]');
          if (head) head.classList.add('is-live');
        });
      })
      .catch(function () { /* tyliai: langelis lieka paslėptas */ });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
